const findIntentQuestion = () => {
  const query = document.getElementsByClassName(
    "tailor-intent-question-experiment",
  );
  if (query.length > 0) return query[0];

  return null;
};

findIntentQuestion()?.addEventListener("change", (e) => {
  const answer = e.target.value;
  if (answer === "idea_of_price") {
    window.showIndicativePricingPopup();
    window.EventTracker?.trigger("tailored_intent_ip_shown");
  }
});
